/**
 * @file The whole seconds left on the tenant's Recompute now cooldown, 0 when
 * none runs. Consumer: `AnalyticsRecomputeButton`, which recomputes it on
 * every clock tick from `analyticsRecompute/latest`, so the countdown survives
 * a reload. The window starts at the last request's `requestedAt`, whatever
 * its status: a failed start still uses the cooldown.
 */
import { ANALYTICS_RECOMPUTE_COOLDOWN_SECONDS } from '#types';
import type { AnalyticsRecompute } from '#types';

export const analyticsRecomputeCooldownLeft = (
  recompute: Readonly<AnalyticsRecompute> | undefined,
  now: number,
): number => {
  if (recompute === undefined) return 0;
  const left =
    Date.parse(recompute.requestedAt) +
    ANALYTICS_RECOMPUTE_COOLDOWN_SECONDS * 1000 -
    now;
  return left > 0 ? Math.ceil(left / 1000) : 0;
};
